/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aml_Form_Create_Pxk_TitleInputs */

const vi_aml_form_create_pxk_title = /** @type {(inputs: Aml_Form_Create_Pxk_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo phiếu xuất kho`)
};

/**

* @param {Aml_Form_Create_Pxk_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aml_form_create_pxk_title = /** @type {((inputs?: Aml_Form_Create_Pxk_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aml_Form_Create_Pxk_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aml_form_create_pxk_title(inputs)
});